import { type TFunctionType } from '@systemeio/util'
import { ContactFiledInterface, getContactFieldTitle } from '@systemeio/ui'
import { CsvExportColumnInterface } from 'shared/components/csv-export-modal'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import {
  ExtraColumnDataItemsIdsEnum,
  extraColumnDataItemsLocoKeys,
} from '../constants/contact-extra-columns-items'
import { UtmParameterEnum, UtmParameterTranslationEnum } from '../enums/utm-parameter-enum'

const getContactColumnsData = ({
  tUi,
  fields,
}: {
  tUi: TFunctionType
  fields: ContactFiledInterface[] | undefined
}): CsvExportColumnInterface<string>[] =>
  fields?.map(el => ({
    id: el.id.toString(),
    caption: getContactFieldTitle(el, tUi),
  })) || []

const getUTMColumnsData = ({ t }: { t: TLocoType }): CsvExportColumnInterface<string>[] =>
  Object.values(UtmParameterEnum)?.map(el => ({
    id: el,
    caption: t(UtmParameterTranslationEnum[el as keyof typeof UtmParameterTranslationEnum]),
  })) || []

export const getExportColumnsData = ({
  t,
  tUi,
  fields,
  needShowUtmParameters,
}: Parameters<typeof getContactColumnsData>[0] &
  Parameters<typeof getUTMColumnsData>[0] & { needShowUtmParameters: boolean | undefined }) => [
  ...getContactColumnsData({ tUi, fields }),
  ...(needShowUtmParameters ? getUTMColumnsData({ t }) : []),
  {
    id: ExtraColumnDataItemsIdsEnum.registered_at,
    caption: t(extraColumnDataItemsLocoKeys[ExtraColumnDataItemsIdsEnum.registered_at]),
  },
  {
    id: ExtraColumnDataItemsIdsEnum.tags,
    caption: t(extraColumnDataItemsLocoKeys[ExtraColumnDataItemsIdsEnum.tags]),
  },
]
